import { ShieldAlert } from 'lucide-react';
import { Link } from 'react-router';
import { Card } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';

export function ForbiddenPage() {
  return (
    <Card>
      <EmptyState
        icon={ShieldAlert}
        title="You don't have access to this page"
        description={
          <>
            Ask your administrator for access, or go back to the{' '}
            <Link to="/dashboard" className="text-brand underline">
              dashboard
            </Link>
            .
          </>
        }
      />
    </Card>
  );
}
